import { render, staticRenderFns } from "./candidatePublicityDetail.vue?vue&type=template&id=224d1795&scoped=true"
import script from "./candidatePublicityDetail.vue?vue&type=script&lang=js"
export * from "./candidatePublicityDetail.vue?vue&type=script&lang=js"
import style0 from "./candidatePublicityDetail.vue?vue&type=style&index=0&id=224d1795&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d1795",
  null
  
)

export default component.exports